/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ExpendituresOnFundsAndExpenseItemsReportExpenseItemDto
 */
export interface ExpendituresOnFundsAndExpenseItemsReportExpenseItemDto {
  /**
   *
   * @type {string}
   * @memberof ExpendituresOnFundsAndExpenseItemsReportExpenseItemDto
   */
  id: string | null;
  /**
   *
   * @type {string}
   * @memberof ExpendituresOnFundsAndExpenseItemsReportExpenseItemDto
   */
  name: string | null;
  /**
   *
   * @type {number}
   * @memberof ExpendituresOnFundsAndExpenseItemsReportExpenseItemDto
   */
  count: number;
  /**
   *
   * @type {number}
   * @memberof ExpendituresOnFundsAndExpenseItemsReportExpenseItemDto
   */
  total: number;
}

export function ExpendituresOnFundsAndExpenseItemsReportExpenseItemDtoFromJSON(
  json: any
): ExpendituresOnFundsAndExpenseItemsReportExpenseItemDto {
  return ExpendituresOnFundsAndExpenseItemsReportExpenseItemDtoFromJSONTyped(json, false);
}

export function ExpendituresOnFundsAndExpenseItemsReportExpenseItemDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExpendituresOnFundsAndExpenseItemsReportExpenseItemDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    count: json["count"],
    total: json["total"],
  };
}

export function ExpendituresOnFundsAndExpenseItemsReportExpenseItemDtoToJSON(
  value?: ExpendituresOnFundsAndExpenseItemsReportExpenseItemDto | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
    count: value.count,
    total: value.total,
  };
}
